module.exports = __webpack_public_path__ + "static/media/when-it-works.8616913b.svg";